import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CommActionItem } from '../../../../interfaces/comm-action-item';
import { Issue } from '../../../../models/issue';
import { SettingsService } from '../../../../services/settings.service';
import { UserstoryService } from '../../../../services/userstory.service';
import { IssuecardHelper } from '../../../../components/issuecard/issuecard.helper';
import { Status } from '../../../../models/status';
import { Statuscategory } from '../../../../models/statuscategory';
import { Userstory } from '../../../../models/userstory';
import { IssuecardComponent } from '../../../issuecard/issuecard.component';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { IssueComponent } from '../../../issue/issue.component';
import { CommunicationService } from '../../../../services/communication.service';
import { ProductBacklogComponent } from '../../../product-backlog/product-backlog.component';
import { AwallComponentEvent } from '../../../../models/awallComponentEvent';
import { ComponentEvent } from '../../../../models/enums/componentEvent';
import { IssueType } from '../../../../models/enums/issueType';
import { OnlineuserService } from '../../../../services/onlineuser.service';
import { PersonService } from '../../../../services/person.service';
import { filter, mergeMap } from 'rxjs';

@Component({
  selector: 'app-action-item',
  templateUrl: './action-item.component.html',
  styleUrls: ['./action-item.component.scss']
  })

export class ActionItemComponent implements OnInit {

  @ViewChild('newBklIssue', { read: ViewContainerRef }) newBacklogIssueComponentChild: ViewContainerRef;

  @Input() public actionItem: CommActionItem;
  @Output() remove = new EventEmitter<number>();

  private projectKey: string;
  public userstories: Userstory[] = [];

  constructor(
    private userstoryService: UserstoryService,
    private issueCardHelper: IssuecardHelper,
    private settingsService: SettingsService,
    private communicationService: CommunicationService,
  ) { }

  ngOnInit(): void {
    this.projectKey = this.settingsService.getProjectName();
    forkJoin([
      this.userstoryService.getUserstoriesFromBacklog(this.projectKey, 'story, task, bug, epic')
    ]).subscribe(([userstories]) => {
      this.userstories = userstories;
    });
  }

  rejectActionItem() {
    this.remove.emit(this.actionItem.id);
  }

  acceptActionItem(event: MouseEvent): void {
    this.openNewIssueDialog(event);
    this.remove.emit(this.actionItem.id);
  }

  onCloseCallback(issueCard: IssuecardComponent): void {
    this.issueCardHelper.removeCardFromGlobalReferences(issueCard);
  }

  onNewIssueCreated(createdIssue: Issue): void {
    this.userstoryService.changeRankOfUserstories(
      this.projectKey,
      new Array(<Userstory>createdIssue),
      this.userstories[0],
      true).subscribe();

    this.communicationService.sendData(
      ProductBacklogComponent.componentId,
      new AwallComponentEvent(
        ComponentEvent.BACKLOG_REQUEST_UPDATE
      ));
  }

  openNewIssueDialog(event: MouseEvent): void {
    // Create new Task
    const newIssueId: number = this.userstoryService.getTemporaryIdForNewIssue();
    const issueComp: IssueComponent = this.createIssueComponent(newIssueId,);
    // Show the IssueCard modal window
    issueComp.createIssuecardForIssue(event, issueComp.issue, false);
  }

  /**
   * Create a new issueComponent for task creation inside story
   * @param issueId parent story ID
   */
  createIssueComponent(issueId: number): IssueComponent {
    // Create new Task
    const statusTodo: Status = new Status('', '', 10000, 'To Do', new Statuscategory('blue-gray', 2, 'new'));
    const type = this.actionItem.issueType.toUpperCase();
    const issueType = IssueType[type as keyof typeof IssueType] ?? IssueType.USERSTORY;

    const newIssue: Userstory = new Userstory(null, this.actionItem.description, undefined, issueId, null, null, this.actionItem.title,
      issueType, null, statusTodo, [], [], null, null, null, false,null, null, null, []);

    // Dynamically create a new Issue in the row
    const componentRef: ComponentRef<IssueComponent> = this.newBacklogIssueComponentChild.createComponent(IssueComponent);
    const issue: IssueComponent = componentRef.instance;
    issue.issue = newIssue;
    issue.projectKey = this.settingsService.getProjectName();
    issue.componentRef = componentRef;

    componentRef.instance.issueCreated.subscribe(createdIssue => {
      this.onNewIssueCreated(createdIssue);
    });
    return issue;
  }
}
